import { API_ENDPOINTS, API_HEADERS } from '../constants/api';

export interface MissionPayload {
  title: string;
  heading: string;
  description: string;
}

export const fetchMission = async (): Promise<MissionPayload | null> => {
  const response = await fetch(API_ENDPOINTS.ourMission, {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(`Mission request failed with status ${response.status}`);
  }

  const data = await response.json();

  if (Array.isArray(data)) {
    return data.length > 0 ? (data[0] as MissionPayload) : null;
  }

  return data as MissionPayload;
};
